const DEVICE_ID_KEY = 'jlpt_device_id'

function generateUuid () {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

function readCookie (name) {
  const prefix = `${name}=`
  const parts = (typeof document !== 'undefined' ? document.cookie : '').split(';')
  for (const part of parts) {
    const item = part.trim()
    if (item.startsWith(prefix)) return decodeURIComponent(item.slice(prefix.length))
  }
  return ''
}

function writeCookie (name, value) {
  if (typeof document === 'undefined') return
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`
}

export function getDeviceId () {
  let id = ''
  try { id = localStorage.getItem(DEVICE_ID_KEY) || '' } catch { /* 隐私模式可能禁用 */ }
  if (!id) id = readCookie(DEVICE_ID_KEY)
  if (!id) id = generateUuid()
  try { localStorage.setItem(DEVICE_ID_KEY, id) } catch { /* 忽略 */ }
  writeCookie(DEVICE_ID_KEY, id)
  return id
}

export function getDeviceName () {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : ''
  // 与库字段 user_devices.device_name varchar(255) 对齐
  return ua.length > 255 ? ua.slice(0, 255) : ua
}
